<template>
    <section id="home" class="bg-emma h-screen pt-56 md:pt-72 relative">
        <div class="flex justify-center gap-24 items-center mx-10 ">
            <div class="text-center">
                <h1 class="text-8xl  text-cv">Emma Nabyt</h1>
                <p class="text-black mt-3">Ecole de communication </p>
            </div>
        </div>
        <div class="flex justify-center">
            <hr class="md:w-1/3 w-1/2 mt-5 border-2 border-cv">
        </div>
        <div class="flex justify-center mt-10">
            <a href="/pdf/CV_EMMA_NABYT.pdf" target="_blank" 
                class="py-2.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white">
                Télécharger mon CV
            </a>
        </div>
        <div class="flex justify-center mt-32">
            <a type="button" href="#about" @click.prevent="scrollToSection('about')"
                class="pb-2.5 pt-1.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white pointer">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M10 18a1 1 0 01-.707-.293l-7-7a1 1 0 011.414-1.414L10 15.586l6.293-6.293a1 1 0 011.414 1.414l-7 7A1 1 0 0110 18z"
                        clip-rule="evenodd" />
                </svg>
            </a>
        </div>
    </section>
</template>
<script>
export default {
  name: 'Header',
  
  methods: {
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
      this.menuOpen = false; // Ferme le menu après le clic
    },
    
  }
};
</script>